export default __webpack_public_path__ + "static/media/cegah (1).f58a3298.png";